import axios from 'axios';
import EventService from '../../utils/event.service';
import buildUrl from 'build-url-ts';
import { IDENTIFY_USER_FOR_ADOPTION, IDENTIFY_USER_FOR_ADOPTION_FAILED, IDENTIFY_USER_FOR_ADOPTION_SUCCEEDED, TRACKING_EVENT_FOR_ADOPTION, TRACKING_EVENT_FOR_ADOPTION_FAILED, TRACKING_EVENT_FOR_ADOPTION_SUCCEEDED } from './actionTypes';
import { createAction } from "@reduxjs/toolkit";
import { takeEvery, takeLatest, call, put } from "redux-saga/effects";
import { TrackEventForAdoptionFailed, TrackEventForAdoptionRequest } from 'src/types/adoption';

// eslint-disable-next-line no-undef
const apiUrl = process.env.REACT_APP_API_URL;
const ADOPTION_BASE_URL = `${apiUrl}/api/2.0/adoption`;

export const identifyUserForAdoption = createAction<void>(IDENTIFY_USER_FOR_ADOPTION);
const identifyingUserForAdoptionSucceeded = createAction<void>(IDENTIFY_USER_FOR_ADOPTION_SUCCEEDED);
const identifyingUserForAdoptionFailed = createAction<void>(IDENTIFY_USER_FOR_ADOPTION_FAILED);

const identifyUserForAdoptionSaga = function* (): any {
  const distinctId = EventService.getMixpanelDistinctId();
  const url = buildUrl(ADOPTION_BASE_URL, {
    path: `/identify/${distinctId}`
  });

  const identifyUserForAdoptionApi = () => {
    return axios({
      method: 'POST',
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(identifyUserForAdoptionApi);
    yield put(identifyingUserForAdoptionSucceeded(response));
  } catch (error) {
    yield put(identifyingUserForAdoptionFailed());
  }
}

export const trackEventForAdoption = createAction<TrackEventForAdoptionRequest>(TRACKING_EVENT_FOR_ADOPTION);
const trackingEventForAdoptionSucceeded = createAction<void>(TRACKING_EVENT_FOR_ADOPTION_SUCCEEDED);
const trackingEventForAdoptionFailed = createAction<TrackEventForAdoptionFailed>(TRACKING_EVENT_FOR_ADOPTION_FAILED);

const trackEventForAdoptionSaga = function* (action: ReturnType<typeof trackEventForAdoption>): any {

  const url = buildUrl(ADOPTION_BASE_URL, {
    path: `/event`
  });

  const distinctId = EventService.getMixpanelDistinctId();
  const event = action.payload;

  if(event && event.properties) {
    event.properties["distinct_id"] = distinctId;
    event.properties["platform"] = "Paperflite Web";
  }

  const eventProperties = {
    ...event,
    properties: event.properties ? JSON.stringify(event.properties) : undefined,
  };

  const trackEventForAdoptionApi = () => {
    return axios({
      method: 'POST',
      url: url,
      data: eventProperties
    }).then((response) => response.data);
  };

  try {
    const response = yield call(trackEventForAdoptionApi);
    yield put(trackingEventForAdoptionSucceeded(response));
  } catch (error) {
    yield put(trackingEventForAdoptionFailed({error}));
  }
};

export default function* adoptionSaga() {
  yield takeEvery(IDENTIFY_USER_FOR_ADOPTION, identifyUserForAdoptionSaga);
  yield takeEvery(TRACKING_EVENT_FOR_ADOPTION, trackEventForAdoptionSaga);
}